<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <!-- VOLTAR -->
          <v-btn text color="primary" class="mb-3" @click="$router.back()">
            <v-icon left>arrow_back</v-icon>
            Voltar
          </v-btn>

          <v-card outlined class="mb-4">
            <v-card-title>Dados do Vereador(a)</v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="4" md="4">
                  <strong>Nome: </strong>

                  <div class="nome-inline mt-1">
                    <div v-if="!editandoNome" class="nome-inline__view">
                      <span class="nome-inline__text">
                        {{ vereador.nome || '-' }}
                      </span>

                      <v-btn
                        icon
                        small
                        class="nome-inline__icon nome-inline__icon--edit"
                        :disabled="salvandoNome || !vereador?.id || !podeEditar"
                        @click="abrirEdicaoNome"
                      >
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                    </div>

                    <div v-else class="nome-inline__edit">
                      <v-text-field
                        v-model="nomeEditado"
                        dense
                        outlined
                        hide-details
                        class="nome-inline__input"
                        :disabled="salvandoNome"
                        @keyup.enter="salvarNome"
                        @keyup.esc="cancelarEdicaoNome"
                      />

                      <v-btn
                        icon
                        small
                        class="nome-inline__icon"
                        :loading="salvandoNome"
                        :disabled="salvandoNome || !nomeEditadoTrim"
                        @click="salvarNome"
                      >
                        <v-icon small color="green">check</v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        small
                        class="nome-inline__icon"
                        :disabled="salvandoNome"
                        @click="cancelarEdicaoNome"
                      >
                        <v-icon small color="red">close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" md="4">
                  <strong>CPF:</strong> {{ cpfFormatado }}
                </v-col>

                <v-col cols="4" md="4">
                  <strong>Situação:</strong>
                  <v-chip
                    small
                    dark
                    class="ml-2"
                    :color="situacaoMandatoColor"
                  >
                    {{ situacaoMandatoLabel }}
                  </v-chip>

                  <div v-if="vereador.situacaoMandato !== 'EM_MANDATO' && vereador.motivoRejeicao" class="mt-1">
                    <strong>Motivo:</strong> {{ vereador.motivoRejeicao }}
                  </div>
                </v-col>
              </v-row>

              <!-- LINHA 2 -->
              <v-row class="mt-2">
                <v-col cols="4" md="4">
                  <strong>Telefone: </strong>

                  <div class="telefone-inline mt-1">
                    <div v-if="!editandoTelefone" class="telefone-inline__view">
                      <span class="telefone-inline__text">
                        {{ telefoneFormatado }}
                      </span>

                      <v-btn
                        icon
                        small
                        class="telefone-inline__icon telefone-inline__icon--edit"
                        :disabled="salvandoTelefone || !vereador?.id || !podeEditar"
                        @click="abrirEdicaoTelefone"
                      >
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                    </div>

                    <div v-else class="telefone-inline__edit">
                      <v-text-field
                        v-model="telefoneEditado"
                        type="tel"
                        inputmode="numeric"
                        dense
                        outlined
                        hide-details
                        class="telefone-inline__input"
                        :disabled="salvandoTelefone"
                        maxlength="15"
                        placeholder="(00) 00000-0000"
                        @input="formatarTelefoneEdicao"
                        @keydown="bloquearTeclaTelefone"
                        @paste.prevent="colarTelefone"
                        @keyup.enter="salvarTelefone"
                        @keyup.esc="cancelarEdicaoTelefone"
                      />

                      <v-btn
                        icon
                        small
                        class="telefone-inline__icon"
                        :loading="salvandoTelefone"
                        :disabled="salvandoTelefone || !telefoneEditadoValido"
                        @click="salvarTelefone"
                      >
                        <v-icon small color="green">check</v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        small
                        class="telefone-inline__icon"
                        :disabled="salvandoTelefone"
                        @click="cancelarEdicaoTelefone"
                      >
                        <v-icon small color="red">close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" md="4">
                  <strong>Email: </strong>

                  <div class="email-inline mt-1">
                    <div v-if="!editandoEmail" class="email-inline__view">
                      <span class="email-inline__text">
                        {{ vereador.email || '-' }}
                      </span>

                      <v-btn
                        icon
                        small
                        class="email-inline__icon email-inline__icon--edit"
                        :disabled="salvandoEmail || !vereador?.id || !podeEditar"
                        @click="abrirEdicaoEmail"
                      >
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                    </div>

                    <div v-else class="email-inline__edit">
                      <v-text-field
                        :value="emailEditado"
                        type="email"
                        dense
                        outlined
                        class="email-inline__input"
                        :disabled="salvandoEmail"
                        autocomplete="email"
                        spellcheck="false"
                        :error="!!emailEditadoTrim && !emailEditadoValido"
                        :error-messages="!!emailEditadoTrim && !emailEditadoValido ? ['Informe um email válido'] : []"
                        @input="formatarEmailEdicao"
                        @keyup.enter="salvarEmail"
                        @keyup.esc="cancelarEdicaoEmail"
                      />

                      <v-btn
                        icon
                        small
                        class="email-inline__icon"
                        :loading="salvandoEmail"
                        :disabled="salvandoEmail || !emailEditadoValido"
                        @click="salvarEmail"
                      >
                        <v-icon small color="green">check</v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        small
                        class="email-inline__icon"
                        :disabled="salvandoEmail"
                        @click="cancelarEdicaoEmail"
                      >
                        <v-icon small color="red">close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>

                <v-col cols="4">
                  <strong>Câmara:</strong>
                  {{ vereador.camara?.nomeFantasia || '-' }}
                </v-col>
              </v-row>

              <!-- LINHA 3 -->
              <v-row class="mt-2">
                <v-col cols="4" md="4">
                  <strong>Início do Mandato:</strong>
                  {{ formatDate(vereador.dataInicioMandato) }}
                </v-col>
                <v-col cols="4" md="4">
                  <strong>Fim do Mandato:</strong>
                  {{ formatDate(vereador.dataFimMandato) }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- HISTÓRICO DE VEÍCULOS -->
          <v-card outlined>
            <v-card-title>Histórico de Veículos</v-card-title>

            <v-card-text>
              <v-data-table :headers="headers" :items="historicoVeiculos" dense>
                <template #item.dataInicioVigencia="{ item }">
                  {{ formatDate(item.dataInicioVigencia) }}
                </template>

                <template #item.dataFimVigencia="{ item }">
                  {{ formatDate(item.dataFimVigencia) }}
                </template>

                <template #item.ativo="{ item }">
                  <v-chip small dark :color="item.ativo ? 'green' : 'red'">
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </v-chip>
                </template>

                <template #no-data>
                  Nenhum veículo registrado.
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import cpvService from '@/services/cpv/cpv.service';
import { SITUACAO_MANDATO_ENUM } from '@/models/cpv/situacaoMandato.enum'

export default {
  name: 'VereadorDetalhes',

  data: () => ({
    vereador: {},
    historicoVeiculos: [],
    editandoNome: false,
    nomeEditado: '',
    salvandoNome: false,
    editandoTelefone: false,
    telefoneEditado: '',
    salvandoTelefone: false,
    editandoEmail: false,
    emailEditado: '',
    salvandoEmail: false,

    headers: [
      { text: 'ID', value: 'id', align: 'center' },
      { text: 'Placa', value: 'placa', align: 'center' },
      { text: 'Marca/Modelo', value: 'marcaModelo', align: 'center' },
      { text: 'Ano de Fabricação', value: 'anoFabricacao' },
      { text: 'Chassi', value: 'chassi', align: 'center' },
      { text: 'Renavam', value: 'renavam', align: 'center' },
      { text: 'Início Vigência', value: 'dataInicioVigencia', align: 'center' },
      { text: 'Fim Vigência', value: 'dataFimVigencia', align: 'center' },
      { text: 'Câmara', value: 'nomeFantasiaCamara', align: 'center' },
      { text: 'Situação', value: 'ativo', align: 'center' },
    ],
  }),

  computed: {
    cpfFormatado() {
      if (!this.vereador.cpf) return '-';
      return this.vereador.cpf.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4'
      );
    },

    podeEditar() {
      return this.vereador?.situacaoMandato === SITUACAO_MANDATO_ENUM.EM_MANDATO.value;
    },

    situacaoMandatoConfig() {
      return SITUACAO_MANDATO_ENUM[this.vereador?.situacaoMandato] || {
        text: this.vereador?.situacaoMandato || '-',
        color: 'grey',
      };
    },

    situacaoMandatoLabel() {
      return this.situacaoMandatoConfig.text;
    },

    situacaoMandatoColor() {
      return this.situacaoMandatoConfig.color;
    },

    telefoneFormatado() {
      return this.formatarTelefone(this.vereador?.telefone);
    },

    nomeEditadoTrim() {
      return (this.nomeEditado || '').trim();
    },

    telefoneEditadoTrim() {
      return (this.telefoneEditado || '').trim();
    },

    telefoneEditadoValido() {
      const digits = this.getTelefoneDigits(this.telefoneEditado);
      return digits.length === 10 || digits.length === 11;
    },

    emailEditadoTrim() {
      return (this.emailEditado || '').trim();
    },

    emailEditadoValido() {
      const email = this.emailEditadoTrim;
      if (!email) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },

  methods: {
    carregarHistoricoVeiculos(vereadorId, camaraId) {
      cpvService.listVehicles({ vereadorId, camaraId }).subscribe({
        next: res => {
          const data = res?.result?.data || [];
          this.historicoVeiculos = data.map(v => ({
            ...v,
            ativo: this.toBool(v.ativo),
          }));
        },
        error: err => {
          console.error('Erro ao buscar histórico de veículos', err);
          this.historicoVeiculos = [];
        },
      });
    },

    toBool(v) {
      if (typeof v === 'boolean') return v;
      if (typeof v === 'number') return v === 1;
      if (typeof v === 'string') {
        const s = v.trim().toLowerCase();
        if (s === 'true' || s === '1') return true;
        if (s === 'false' || s === '0') return false;
      }
      return false;
    },

    formatDate(date) {
      if (!date) return '-';
      const [ano, mes, dia] = date.split('-');
      return `${dia}/${mes}/${ano}`;
    },

    getTelefoneDigits(value) {
      return String(value || '')
        .replace(/\D/g, '')
        .slice(0, 11);
    },

    formatarTelefone(value) {
      const digits = this.getTelefoneDigits(value);

      if (!digits) return '';

      if (digits.length <= 2) {
        return `(${digits}`;
      }

      if (digits.length <= 6) {
        return digits.replace(/^(\d{2})(\d+)/, '($1) $2');
      }

      if (digits.length <= 10) {
        return digits.replace(/^(\d{2})(\d{4})(\d+)/, '($1) $2-$3');
      }

      return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    },

    bloquearTeclaTelefone(e) {
      const teclasPermitidas = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Home',
        'End',
      ];

      if (teclasPermitidas.includes(e.key) || e.ctrlKey || e.metaKey) {
        return;
      }

      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },

    colarTelefone(e) {
      const textoColado = e.clipboardData.getData('text') || '';
      this.telefoneEditado = this.formatarTelefone(textoColado);
    },

    formatarTelefoneEdicao(value) {
      this.telefoneEditado = this.formatarTelefone(value);
    },

    formatarEmailEdicao(value) {
      this.emailEditado = String(value || '')
        .replace(/\s/g, '')
        .toLowerCase();
    },

    abrirEdicaoNome() {
      if (!this.podeEditar) return;

      this.nomeEditado = this.vereador?.nome || '';
      this.editandoNome = true;
      this.$nextTick(() => {
        const input = this.$el?.querySelector('.nome-inline__input input');
        if (input) input.focus();
      });
    },

    cancelarEdicaoNome() {
      this.editandoNome = false;
      this.nomeEditado = '';
      this.salvandoNome = false;
    },

    salvarNome() {
      if (!this.podeEditar) return;

      const novoNome = this.nomeEditadoTrim;
      if (!novoNome || !this.vereador?.id) return;

      this.salvandoNome = true;

      const payload = {
        id: this.vereador.id,
        cpf: this.vereador.cpf,
        nome: novoNome,
        telefone: this.vereador.telefone,
        email: this.vereador.email,
        dataFimVigencia: this.vereador.dataFimVigencia || this.vereador.dataFimMandato,
        situacaoMandato: this.vereador.situacaoMandato,
        camaraId: String(this.vereador.camaraId || this.vereador.camara?.id || ''),
      };

      cpvService.patchVereador(this.vereador.id, payload).subscribe({
        next: () => {
          this.vereador = {
            ...this.vereador,
            nome: novoNome,
          };

          this.salvandoNome = false;
          this.editandoNome = false;
          this.nomeEditado = '';
        },
        error: err => {
          console.error('Erro ao atualizar vereador', err);
          this.salvandoNome = false;
        },
      });
    },

    abrirEdicaoTelefone() {
      if (!this.podeEditar) return;

      this.telefoneEditado = this.formatarTelefone(this.vereador?.telefone || '');
      this.editandoTelefone = true;
      this.$nextTick(() => {
        const input = this.$el?.querySelector('.telefone-inline__input input');
        if (input) input.focus();
      });
    },

    cancelarEdicaoTelefone() {
      this.editandoTelefone = false;
      this.telefoneEditado = '';
      this.salvandoTelefone = false;
    },

    salvarTelefone() {
      if (!this.podeEditar) return;

      const telefoneDigits = this.getTelefoneDigits(this.telefoneEditado);
      if (!(telefoneDigits.length === 10 || telefoneDigits.length === 11) || !this.vereador?.id) return;

      this.salvandoTelefone = true;

      const payload = {
        id: this.vereador.id,
        cpf: this.vereador.cpf,
        nome: this.vereador.nome,
        telefone: telefoneDigits,
        email: this.vereador.email,
        dataFimVigencia: this.vereador.dataFimVigencia || this.vereador.dataFimMandato,
        situacaoMandato: this.vereador.situacaoMandato,
        camaraId: String(this.vereador.camaraId || this.vereador.camara?.id || ''),
      };

      cpvService.patchVereador(this.vereador.id, payload).subscribe({
        next: () => {
          this.vereador = {
            ...this.vereador,
            telefone: telefoneDigits,
          };

          this.salvandoTelefone = false;
          this.editandoTelefone = false;
          this.telefoneEditado = '';
        },
        error: err => {
          console.error('Erro ao atualizar telefone do vereador', err);
          this.salvandoTelefone = false;
        },
      });
    },

    abrirEdicaoEmail() {
      if (!this.podeEditar) return;

      this.emailEditado = String(this.vereador?.email || '')
        .replace(/\s/g, '')
        .toLowerCase();

      this.editandoEmail = true;
      this.$nextTick(() => {
        const input = this.$el?.querySelector('.email-inline__input input');
        if (input) input.focus();
      });
    },

    cancelarEdicaoEmail() {
      this.editandoEmail = false;
      this.emailEditado = '';
      this.salvandoEmail = false;
    },

    salvarEmail() {
      if (!this.podeEditar) return;

      const novoEmail = this.emailEditadoTrim;
      if (!this.emailEditadoValido || !this.vereador?.id) return;

      this.salvandoEmail = true;

      const payload = {
        id: this.vereador.id,
        cpf: this.vereador.cpf,
        nome: this.vereador.nome,
        telefone: this.vereador.telefone,
        email: novoEmail,
        dataFimVigencia: this.vereador.dataFimVigencia || this.vereador.dataFimMandato,
        situacaoMandato: this.vereador.situacaoMandato,
        camaraId: String(this.vereador.camaraId || this.vereador.camara?.id || ''),
      };

      cpvService.patchVereador(this.vereador.id, payload).subscribe({
        next: () => {
          this.vereador = {
            ...this.vereador,
            email: novoEmail,
          };

          this.salvandoEmail = false;
          this.editandoEmail = false;
          this.emailEditado = '';
        },
        error: err => {
          console.error('Erro ao atualizar email do vereador', err);
          this.salvandoEmail = false;
        },
      });
    },
  },

  created() {
    const id = Number(this.$route.params.id);

    cpvService.getById(id).subscribe({
      next: res => {
        this.vereador = res.result;

        const camaraId = this.vereador?.camaraId || this.vereador?.camara?.id;
        this.carregarHistoricoVeiculos(id, camaraId);
      },
      error: err => {
        console.error('Erro ao buscar vereador', err);
        this.vereador = {};
        this.historicoVeiculos = [];
      },
    });
  },
};
</script>

<style scoped>
.nome-inline {
  display: inline-flex;
  align-items: center;
  max-width: 520px;
}

.nome-inline__view {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  padding: 2px 0;
}

.nome-inline__text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  max-width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nome-inline__icon {
  opacity: 1;
  transition: transform 0.12s ease;
}

.nome-inline__icon:hover {
  transform: translateY(-1px);
}

.nome-inline__edit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.nome-inline__input {
  width: 360px;
  max-width: 100%;
}

.nome-inline__input :deep(.v-input__slot) {
  margin-bottom: 0 !important;
}

.telefone-inline {
  display: inline-flex;
  align-items: center;
  max-width: 520px;
}

.telefone-inline__view {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  padding: 2px 0;
}

.telefone-inline__text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  max-width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.telefone-inline__icon {
  opacity: 1;
  transition: transform 0.12s ease;
}

.telefone-inline__icon:hover {
  transform: translateY(-1px);
}

.telefone-inline__edit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.telefone-inline__input {
  width: 360px;
  max-width: 100%;
}

.telefone-inline__input :deep(.v-input__slot) {
  margin-bottom: 0 !important;
}

.email-inline {
  display: inline-flex;
  align-items: center;
  max-width: 520px;
}

.email-inline__view {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  padding: 2px 0;
}

.email-inline__text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  max-width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.email-inline__icon {
  opacity: 1;
  transition: transform 0.12s ease;
}

.email-inline__icon:hover {
  transform: translateY(-1px);
}

.email-inline__edit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.email-inline__input {
  width: 360px;
  max-width: 100%;
}

.email-inline__input :deep(.v-input__slot) {
  margin-bottom: 0 !important;
}
</style>
